"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputField = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const InputField = exports.InputField = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    autoComplete,
    name,
    required,
    autoFocus,
    value,
    onKeyDown,
    onChange,
    onFocus,
    onBlur,
    disabled,
    invalid,
    type,
    fieldType = 'default',
    placeholder,
    errorMessage,
    addon,
    tabIndex,
    hidden
  } = _ref;
  const inputType = type || 'text';
  const hasError = invalid || Boolean(errorMessage);
  const maxLength = fieldType === 'pin' ? 1 : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)({
      [styles['container']]: true,
      [styles['container--hidden']]: hidden,
      [styles['container--pin']]: fieldType === 'pin'
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['input-group'], {
      [styles['input-group--required']]: required
    })
  }, /*#__PURE__*/React.createElement("input", {
    name: name,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    type: inputType,
    placeholder: placeholder,
    ref: ref,
    tabIndex: tabIndex,
    className: (0, _classnames.default)({
      [styles['input']]: true,
      [styles['input-disabled']]: disabled,
      [styles['input-invalid']]: hasError
    }),
    value: value,
    maxLength: maxLength,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    disabled: disabled
  }), addon && /*#__PURE__*/React.createElement("div", {
    className: styles['input-addon'],
    "data-testid": "addon"
  }, addon)), errorMessage && /*#__PURE__*/React.createElement("span", {
    className: styles['error-message']
  }, errorMessage));
});
InputField.displayName = 'InputField';